// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UYx3","col":"styles_col__SJcgt"};